<template>
    <div>
        <vue-chart ref="canvas"
                   :type="type"
                   class="chart-item"
                   style="height: 250px;"
                   :options="options"
                   :data="chartData"
                   v-if="hideGraph === false"
        />
        <img :src="image" alt="image" class="graph-image" v-if="image !== false">
    </div>
</template>

<script>
    import VueChart from 'vue-chart-js'

    export default {
        components: {
            VueChart
        },
        props: {
            options: {
                type: Object,
                required: true,
            },
            chartData: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                default: 'line',
            }
        },
        methods: {
            renderImage() {
                if (this.image === false) {
                    this.image = this.$refs.canvas.chart.canvas.toDataURL('image/png');
                    setTimeout(() => {
                        this.hideGraph = true;
                    }, 100);
                }
            },
            renderGraph() {
                this.image = false;
                this.hideGraph = false;
            }
        },
        data: () => {
            return {
                image: false,
                hideGraph: false,
            }
        }
    }
</script>
<style lang="scss">
    .chart-item {
        width: 100%;
        max-width: 1078px;
    }

    img.graph-image {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/report/graph.vue